import { Position, OverlayToaster } from '@blueprintjs/core';
import { CLASS_NAME } from './ModellingNotifications.styles';

export const ModellingNotifications = OverlayToaster.create({
  position: Position.TOP_RIGHT,
  className: CLASS_NAME,
});
